import { render } from "./product-gallery-zoom.vue?vue&type=template&id=4914a307"
import script from "./product-gallery-zoom.vue?vue&type=script&lang=js"
export * from "./product-gallery-zoom.vue?vue&type=script&lang=js"

import "./product-gallery-zoom.vue?vue&type=style&index=0&id=4914a307&lang=scss"

import exportComponent from "/Users/bornasepic/Desktop/projects/grau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__